import React from 'react';

const ProfileList = ({ profile }) => (
  <ul className="profile-list fadeInRight animated">

    <li>
      <div className="column-left">company</div>
      <div className="column-right">{profile.company}</div>
    </li>
    <li>
      <div className="column-left">position</div>
      <div className="column-right">{profile.position}</div>
    </li>
    <li>
      <div className="column-left">hobbies</div>
      <div className="column-right">{profile.hobbies}</div>
    </li>
    <li>
      <div className="column-left">location</div>
      <div className="column-right">{profile.location}</div>
    </li>
    <li>
      <div className="column-left">age</div>
      <div className="column-right">{profile.age}</div>
    </li>
  </ul>
);

export default ProfileList;



// WEBPACK FOOTER //
// ./src/components/LockHomeDemo/components/ProfileList.js